export const FETCH_ERRORS = {
    noAccessToken: 'NoAccessTokenError',
    userNotAuthorised: 'UserNotAuthorisedError',
};
